import _isEmpty from 'lodash/isEmpty';
export function markdownToPlainText(markdown) {
  if (_isEmpty(markdown)) {
    return '';
  }

  // Remove headers
  var plainText = markdown.replace(/^#+\s+/gm, '');

  // Replace links and images
  plainText = plainText.replace(/!\[([^\]]+)\]\([^)]+\)/g, '$1');
  plainText = plainText.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

  // Remove emphasis
  plainText = plainText.replace(/(\*\*|__)(.*?)(\*\*|__)/g, '$2');
  plainText = plainText.replace(/(\*|_)(.*?)(\1)/g, '$2');

  // Handle lists (ordered and unordered)
  plainText = plainText.replace(/^\s*[*-]\s+/gm, '');
  plainText = plainText.replace(/^\s*\d+\.\s+/gm, '');

  // Handle blockquotes
  plainText = plainText.replace(/^\s*>+\s+/gm, '');

  // Handle code blocks
  plainText = plainText.replace(/```[^`]+```/g, '');

  // Handle inline code
  plainText = plainText.replace(/`([^`]+)`/g, '$1');

  // Handle horizontal lines
  plainText = plainText.replace(/^---$/gm, '');
  return plainText.trim();
}